export default __webpack_public_path__ + "static/media/about-us.72517996.svg";